/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighestJpkIdDto
 */
export interface HighestJpkIdDto {
    /**
     * 
     * @type {number}
     * @memberof HighestJpkIdDto
     */
    jpkId: number;
}

/**
 * Check if a given object implements the HighestJpkIdDto interface.
 */
export function instanceOfHighestJpkIdDto(value: object): value is HighestJpkIdDto {
    if (!('jpkId' in value) || value['jpkId'] === undefined) return false;
    return true;
}

export function HighestJpkIdDtoFromJSON(json: any): HighestJpkIdDto {
    return HighestJpkIdDtoFromJSONTyped(json, false);
}

export function HighestJpkIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighestJpkIdDto {
    if (json == null) {
        return json;
    }
    return {
        
        'jpkId': json['jpkId'],
    };
}

export function HighestJpkIdDtoToJSON(value?: HighestJpkIdDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jpkId': value['jpkId'],
    };
}

